const CloseCircleFill = ({ width = 16, height = 16, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        d="M8.00065 14.6668C4.31865 14.6668 1.33398 11.6822 1.33398 8.00016C1.33398 4.31816 4.31865 1.3335 8.00065 1.3335C11.6827 1.3335 14.6673 4.31816 14.6673 8.00016C14.6673 11.6822 11.6827 14.6668 8.00065 14.6668ZM8.00065 7.0575L6.11532 5.1715L5.17198 6.11483L7.05798 8.00016L5.17198 9.8855L6.11532 10.8288L8.00065 8.94283L9.88598 10.8288L10.8293 9.8855L8.94332 8.00016L10.8293 6.11483L9.88598 5.1715L8.00065 7.0575Z"
        fill={color}
      />
    </svg>
  )
}

export default CloseCircleFill
